import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, func } from 'prop-types';
import { startSetSiteSettings } from '../../actions/app';
import { startAddSite } from '../../actions/sites';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import AddSourceForm from '../../components/Sources/AddSourceForm';
import webmaster from '../../reducers/webmaster';

export class CreateSourcePage extends Component {
  static propTypes = {
    types: array.isRequired,
    startSetSiteSettings: func.isRequired,
  };

  static defaultProps = {
    types: [],
  };

  submit = data => {
    this.props.startAddSite(data).then(() => {
      this.props.history.push('/tools/sources');
    });
  };

  componentDidMount() {
    this.props.startSetSiteSettings();
  }

  render() {
    const { types, theme } = this.props;

    return (
      <Layout formattedTitle="pages.create-source.title">
        <Layout.Col lg={{ size: 10, offset: 1 }} xl={{ size: 8, offset: 2 }}>
          <Card>
            <Card.Header>
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link to="/tools/sources">
                    <FormattedMessage id="sources.breadcrumb" defaultMessage="All sources" />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <FormattedMessage id="source.breadcrumb" defaultMessage="New Source" />
                </BreadcrumbItem>
              </Breadcrumb>
            </Card.Header>
            <Card.Body>
              <h2>
                <FormattedMessage id="source.create" defaultMessage="Create Source" />
              </h2>
              <AddSourceForm theme={theme} types={types} submit={this.submit} />
            </Card.Body>
          </Card>
        </Layout.Col>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  types: state.app.settings.site,
  theme: state.webmaster.profile.theme,
});

const mapDispatchToProps = dispatch => ({
  startSetSiteSettings: () => dispatch(startSetSiteSettings()),
  startAddSite: siteData => dispatch(startAddSite(siteData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateSourcePage);
